module.exports = __webpack_public_path__ + "img/frame1.8ed31ada.jpg";